import request from "@utils/request";

export function getMTDVolume(query) {
    return request({
        url: "statistic/mtd-volume",
        method: "post",
        data: query
    });
}
